import { gql } from '@apollo/client';
import { DealDetailsFragment } from '../fragments/DealDetailsFragment';
/**
 * @const DealDetailsQuery
 * @since 1.0.0
 */
export const DealDetailsQuery = gql `
  query DealDetailsQuery($input: DealInput!) {
    deal(input: $input) {
      ...DealDetailsFragment
    }
  }

  ${DealDetailsFragment}
`;
